<script setup lang="ts">
/** What a place looks like before it holds anything: an optional glyph, a headline, one sentence, at most one action. */
defineProps<{ title: string; body?: string | undefined }>()
</script>

<template>
  <div
    class="flex flex-col items-center gap-[var(--space-inline)] rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-[var(--space-block)] py-[var(--space-section)] text-center"
  >
    <span
      v-if="$slots.icon"
      class="mb-[var(--space-tight)] flex h-10 w-10 items-center justify-center rounded-full bg-[color:var(--color-surface-sunken)] text-[color:var(--color-text-muted)]"
    >
      <slot name="icon" />
    </span>
    <p
      class="font-[family-name:var(--font-display)] tracking-[var(--tracking-tight)] text-[length:var(--text-step-5)] font-semibold text-[color:var(--color-text)]"
    >
      {{ title }}
    </p>
    <p v-if="body" class="max-w-[42ch] text-[length:var(--text-step-3)] text-[color:var(--color-text-muted)]">
      {{ body }}
    </p>
    <div v-if="$slots.action" class="mt-[var(--space-inline)]">
      <slot name="action" />
    </div>
  </div>
</template>
